<template>
  <div class="cfdis-related-replacement box">
    <div class="is-pulled-right">
      <BButton
        v-if="! disabled"
        class="button-search-documents"
        type="is-primary"
        icon-left="magnify"
        outlined
        :disabled="!(customer)"
        @click="openModal('CfdisRelated')"
      >
        Buscar documentos
      </BButton>
    </div>
    <p class="title is-4 has-text-primary title-return-uuids">
      CFDI Relacionados
    </p>
    <div
      v-for="relationType in uuidsRelated"
      :key="relationType.key"
      class="field"
    >
      <label class="label"> {{ relationType.key }} - {{ relationType.value }}</label>
      <BTaginput
        v-model="relationType.uuids"
        icon="label"
        :disabled="disabled"
        @add="onInput($event, relationType.key)"
        @remove="onDelete"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';

const replacementTypesByDocument = {
  replacementInvoice: ['04', '06', '07'],
  replacementCreditNote: ['01', '03', '04', '07'],
  replacementTradeTransfer: ['04', '05'],
  replacementRep: ['04'],
};

export default {
  name: 'CfdisRelatedReplacement',
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    replacementType: {
      type: String,
      default: '',
    },
  },
  computed: {
    ...mapState({
      show: state => state.modalForm.show,
      cfdisRelated: state => state.invoice.cfdisRelated,
      customer: state => state.customers.id,
      invoice: state => state.invoice,
      relationTypeCatalog: ({ ui }) => ui.catalogSat.relationType,
    }),
    uuidsRelated() {
      const cfdis = replacementTypesByDocument[this.replacementType].map((key) => {
        const relationTypeCatalog = this.relationTypeCatalog.find(i => i.key === key);
        const currentCfdis = this.cfdisRelated.find(related => related.relationType === key);

        return {
          key,
          value: relationTypeCatalog.value,
          uuids: currentCfdis ? currentCfdis.uuids : [],
        };
      });

      return cfdis;
    },
  },
  methods: {
    onInput(event, type) {
      this.$store.commit('invoice/deleteUuidsRelated', { uuid: event });
      this.$store.commit('invoice/addCfdiRelated', { type, uuid: event });
    },
    onDelete(event) {
      this.$store.commit('invoice/deleteUuidsRelated', { uuid: event });
    },
    openModal(component) {
      const { customer } = this;

      if (customer) {
        this.$modalForm({
          width: '1200px',
          show: true,
          component,
          props: {
            customer,
            replacementType: this.replacementType,
            replacementTypesByDocument,
          },
        });
      }
    },
  },
};
</script>
